import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { RoleBadge } from '#client/components/ui/StatusBadge';
import { useAuth } from '#client/providers/AuthProvider';
import { type User, formatPersonName } from '#shared/types';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<User>[] = [
  {
    key: 'name',
    header: 'Name',
    render: (row) => <strong>{formatPersonName(row)}</strong>,
  },
  { key: 'email', header: 'Email', render: (row) => row.email },
  { key: 'phone_number', header: 'Phone', render: (row) => row.phone_number },
  { key: 'field', header: 'Field', render: (row) => row.field },
  {
    key: 'role',
    header: 'Role',
    render: (row) => <RoleBadge role={row.role} />,
    width: '140px',
  },
];

export function UserListPage() {
  const { user: currentUser } = useAuth();

  return (
    <ResourceListPage<User>
      title="Staff"
      subtitle="Accounts and their roles"
      path={RESOURCE.users}
      columns={columns}
      noun="user"
      nounPlural="users"
      searchPlaceholder="Search by name, email or phone"
      rowLabel={formatPersonName}
      // Deleting your own account would immediately invalidate your session.
      canDeleteRow={(row) => row.id !== currentUser?.id}
      // Each control is gated server-side on its own permission; hiding them
      // keeps the UI honest rather than showing buttons that 403.
      createCapability="staff.create"
      editCapability="staff.edit"
      deleteCapability="staff.delete"
    />
  );
}
